export default {
    'restore-all-samples': 'Restore all samples',
    'samples-summary': 'Samples Summary',
    'remaining-samples': 'Remaining Samples',
    'from-the-selected-medical-rep-to-her-/-his-line-manager': 'from the selected medical rep to her / his line manager'
}